import { applyMiddleware, compose, createStore } from 'redux';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { configInstance } from '../config';
import createRootReducer from '../reducers';
import rootSaga from '../sagas';
var sagaMiddleware = createSagaMiddleware();
var reducers = createRootReducer();
var configureStore = function (reducer) {
    return createStore(reducer, compose(configInstance === 'dev' || configInstance === 'stage' || configInstance === 'local'
        ? applyMiddleware(sagaMiddleware, logger)
        : applyMiddleware(sagaMiddleware)));
};
export var store = configureStore(reducers);
sagaMiddleware.run(rootSaga);
//# sourceMappingURL=configureStore.js.map